import { connect } from 'react-redux';

import {
  getAllConfigsAction,
  getAllCyclesAction,
  setConfigAction,
} from '../actionSagas';
import {
  getConfigsSelector,
  getCyclesSelector,
  getLoadingSelector,
} from '../selectors';
import SelfPromotion from './SelfPromotion';

const mapStateToProps = (state) => ({
  configs: getConfigsSelector(state),
  cycles: getCyclesSelector(state),
  loading: getLoadingSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllConfigs: () => dispatch(getAllConfigsAction()),
  getAllCycles: () => dispatch(getAllCyclesAction()),
  setConfig: (cycleId, rank, dutyState, enabled) =>
    dispatch(setConfigAction(cycleId, rank, dutyState, enabled)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelfPromotion);
